

import React, { useState } from 'react';

const ONRC_eKYC_Details = ({ data }) => {
    const { stateName, otherStateName, rows } = data;
    const [search, setSearch] = useState("");
    const [perPage, setPerPage] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);
    const [showAll, setShowAll] = useState(false);

    if (!rows || rows.length === 0) {
        return (
            <div className="mainhead" align="center">
                Details not found for
            </div>
        );
    }

    const normalize = (value) => {
        if (value == null) return "";
        const num = Number(value);
        return isNaN(num) ? String(value).toLowerCase() : String(num);
    };

    const filteredRows = rows.filter(row => {
        const searchText = normalize(search);
        const rowValues = [
            row.rc_id,
            row.member_id,
            row.poi_name,
            row.uid,
            row.poi_gender,
            row.updated_time
        ];
        const rowString = rowValues
            .map(v => normalize(v))
            .join(" ")
            .toLowerCase();
        return rowString.includes(searchText);
    }) || [];

    const totalPages = showAll ? 1 : Math.ceil(filteredRows.length / perPage);
    const startIndex = showAll ? 0 : (currentPage - 1) * perPage;
    const endIndex = showAll ? filteredRows.length : Math.min(startIndex + perPage, filteredRows.length);
    const paginatedRows = filteredRows.slice(startIndex, endIndex);

    const pageBtn = {
        background: "#3c4fbdff",
        color: "white",
        textDecoration: "underline",
        marginRight: "5px",
        padding: "2px 7px",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer"
    };

    return (
        <div>
            <style>{`
                .tableheader { background: #f1872bff; color: black; font-weight: bold; }
            `}</style>
            <div style={{ width: "80%", marginBottom: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ flex: 1, textAlign: "center" }}>
                    <span>per page </span>
                    <select
                        value={showAll ? "All" : perPage}
                        onChange={(e) => {
                            if (e.target.value === "All") {
                                setShowAll(true);
                            } else {
                                setShowAll(false);
                                setPerPage(Number(e.target.value));
                            }
                            setCurrentPage(1);
                        }}
                        style={{ margin: "0 5px" }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value="All">All</option>
                    </select>
                </div>
            </div>
            <div style={{
                width: "80%",
                marginBottom: "15px",
                display: "flex",
                justifyContent: "flex-end"
            }}>
                <div style={{
                    position: "relative",
                    display: "inline-block",
                    textAlign: "right"
                }}>
                    <span style={{ marginRight: "5px" }}>Search</span>
                    <input
                        type="text"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setCurrentPage(1);
                        }}
                        style={{
                            paddingRight: "25px",
                        }}
                    />
                    {search && (
                        <span
                            onClick={() => {
                                setSearch("");
                                setCurrentPage(1);
                            }}
                            style={{
                                position: "absolute",
                                right: 6,
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                fontWeight: "bold",
                                fontSize: "12px",
                                userSelect: "none",
                            }}
                            title="Clear Search"
                        >
                            ✖
                        </span>
                    )}
                </div>
            </div>
            <table id="Report" width="80%" align="center" border="1">
                <thead>
                    <tr className="tableheader">
                        <th colSpan="7">{stateName} eKYC done in {otherStateName} Details</th>
                    </tr>
                    <tr className="tableheader">
                        <th>Sl.No</th>
                        <th>RC N0</th>
                        <th>Member Id</th>
                        <th>Member Name</th>
                        <th>UID</th>
                        <th>Gender</th>
                        <th>eKYC<br/>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedRows.map((row, index) => (
                        <tr key={index}>
                            <td>{startIndex + index + 1}</td>
                            <td>{row.rc_id}</td>
                            <td>{row.member_id}</td>
                            <td>{row.poi_name}</td>
                            <td>{row.uid}</td>
                            <td>{row.poi_gender}</td>
                            <td>{row.updated_time}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div style={{ width: "80%", marginTop: "10px", marginRight: "17px",display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0" }}>
                <div style={{ color: "#792020ff", fontWeight: "bold", textAlign: "left", flex: 1 }}>
                    Showing {filteredRows.length > 0 ? startIndex + 1 : 0} to {endIndex} of {filteredRows.length} entries
                </div>
                {!showAll && (
                    <div style={{ textAlign: "right", flex: 1, whiteSpace: "nowrap" }}>
                        <button
                            onClick={() => setCurrentPage(1)}
                            disabled={currentPage === 1}
                            style={pageBtn}
                        >
                            First
                        </button>
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            style={pageBtn}
                        >
                            Previous
                        </button>
                        {[...Array(totalPages)].map((_, i) => {
                            if (
                                i === 0 ||
                                i === totalPages - 1 ||
                                (i >= currentPage - 2 && i <= currentPage + 1)
                            ) {
                                return (
                                    <button
                                        key={i}
                                        onClick={() => setCurrentPage(i + 1)}
                                        style={{
                                            ...pageBtn,
                                            background: currentPage === i + 1 ? "black" : "#3c4fbdff"
                                        }}
                                    >
                                        {i + 1}
                                    </button>
                                );
                            } else if (i === currentPage - 3 || i === currentPage + 2) {
                                return <span key={i} style={{ marginRight: "5px" }}>...</span>;
                            }
                            return null;
                        })}
                        <button
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            style={pageBtn}
                        >
                            Next
                        </button>
                        <button
                            onClick={() => setCurrentPage(totalPages)}
                            disabled={currentPage === totalPages}
                            style={pageBtn}
                        >
                            Last
                        </button>
                    </div>
                )}
            </div>
            <br /><br />
            <br></br><br></br><br></br><br></br><br></br>
        </div>
    );
};

export default ONRC_eKYC_Details;




